import { extendTheme } from '@chakra-ui/react';
var theme = extendTheme({
    colors: {
        brand: {
            50: '#e6f6fd',
            100: '#c2e7f7',
            200: '#9dd7f1',
            300: '#78c7eb',
            400: '#54b7e5',
            500: '#33a1d1',
            600: '#2581a7',
            700: '#195f7e',
            800: '#0d3d54',
            900: '#021c2a',
        },
    },
    fonts: {
        heading: '"Inter", sans-serif',
        body: '"Inter", sans-serif',
    },
    components: {
        Button: {
            baseStyle: {
                fontWeight: 'semibold',
            },
            variants: {
                solid: function (props) { return ({
                    bg: props.colorScheme === 'brand' ? 'brand.500' : undefined,
                    color: 'white',
                    _hover: {
                        bg: props.colorScheme === 'brand' ? 'brand.600' : undefined,
                    },
                }); },
            },
        },
    },
});
export default theme;
